import { StandardEvents } from '@shopify/events';

function toDataLayerItems(lines) {
  return lines.map((line) => ({
    item_id: line.merchandiseId,
    quantity: Math.abs(line.quantity ?? 0),
  }));
}

document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  if (!Array.isArray(window.dataLayer)) return;

  const { action, lines } = event;
  if (!action || !Array.isArray(lines) || lines.length === 0) return;

  const eventName = action === 'add' ? 'add_to_cart' : action === 'remove' ? 'remove_from_cart' : null;
  if (!eventName) return;

  event.promise
    ?.then(({ detail }) => {
      if (detail?.didError) return;

      window.dataLayer.push({
        event: eventName,
        ecommerce: { items: toDataLayerItems(lines) },
      });
    })
    .catch(() => {});
});
